export const START_UNORDERED_LIST_COMMAND = 'start-unordered-list';
export const START_ORDERED_LIST_COMMAND = 'start-ordered-list';

export const SPACE_KEY = ' ';
export const STAR_KEY = '*';
export const DASH_KEY = '-';
export const ORDERED_LIST_START = '1.';
export const ENTER_KEY = 'Enter';
export const TAB_KEY = 'Tab';

export const listTypeMap = {
  [START_UNORDERED_LIST_COMMAND]: 'unordered-list-item',
  [START_ORDERED_LIST_COMMAND]: 'ordered-list-item',
};
